import {Component, HostListener, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";

export interface ServerResponse {
    result: string;
}


@Component({
    selector: 'app-shareholders-form',
    templateUrl: './shareholders-form.component.html',
    styleUrls: ['./shareholders-form.component.scss']
})
export class ShareholdersFormComponent implements OnInit {

    shareholderForm: FormGroup
    validateForm = false;
    showSummary = false;
    assetsNumberInvalid = false;
    correspondenceSame = false;
    showThankYou = false;
    errorMessage = '';

    get assets() {
        return this.shareholderForm.get('assets') as FormArray
    }

    get validatedData() {
        return this.shareholderForm.value
    }

    get isPerson() {
        return this.formControl('companySelect').value === 'person';
    }

    formControl(name) {
        return this.shareholderForm.get(name) as FormControl
    }

    formControlErrors(name) {
        return this.shareholderForm.get(name).errors || {};
    }

    constructor(private fb: FormBuilder, private http: HttpClient) {
    }

    ngOnInit(): void {
        this.buildForm()
    }

    buildForm(): void {

        this.shareholderForm = this.fb.group({
            correspondenceSame: [false],

            companySelect: ['person'],

            email: ['', [Validators.required, Validators.email]],

            firstname: ['', [Validators.required]],
            lastname: ['', [Validators.required]],
            pesel: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],

            companyName: [''],
            regon: [''],

            phone: [''],

            zgoda: ['', [Validators.required, Validators.requiredTrue]],

            brokerage: ['', [Validators.required]],
            makler: ['', [Validators.required]],

            assetsTotalQty: [''],
            assets: this.fb.array([
                this.fb.group({
                    number: ['', []],
                    qty: ['', []],
                    price: [''],
                    set: ['', []],
                    date: [''],
                })
            ])

        })

        this.shareholderForm.get('correspondenceSame').valueChanges.subscribe(value => {
            this.correspondenceSame = value;
        });
        this.shareholderForm.get('companySelect').valueChanges.subscribe(value => {

            if (value === 'company') {
                this.formControl('firstname').setValidators(null);
                this.formControl('lastname').setValidators(null);
                this.formControl('pesel').setValidators(null);
                this.formControl('firstname').setValue(null);
                this.formControl('lastname').setValue(null);
                this.formControl('pesel').setValue(null);

                this.formControl('companyName').setValidators([Validators.required]);

                this.formControl('regon').setValidators([Validators.required]);
            } else {
                this.formControl('firstname').setValidators([Validators.required]);
                this.formControl('lastname').setValidators([Validators.required]);

                this.formControl('pesel').setValidators([Validators.required, Validators.minLength(11), Validators.maxLength(11)]);

                this.formControl('companyName').setValidators(null);

                this.formControl('regon').setValidators(null);
                this.formControl('companyName').setValue(null);

                this.formControl('regon').setValue(null);

            }

            this.formControl('firstname').updateValueAndValidity();
            this.formControl('lastname').updateValueAndValidity();
            this.formControl('birthDate').updateValueAndValidity();
            this.formControl('pesel').updateValueAndValidity();
            this.formControl('idnumber').updateValueAndValidity();

            this.formControl('companyName').updateValueAndValidity();
            this.formControl('krs').updateValueAndValidity();
            this.formControl('nip').updateValueAndValidity();
            this.formControl('regon').updateValueAndValidity();

            this.shareholderForm.updateValueAndValidity();

        })

    }

    removeAssetROw(idx) {
        this.assets.removeAt(idx);
        this.shareholderForm.updateValueAndValidity();
    }

    addAssetRow() {

        this.assets.push(
            this.fb.group({
                number: ['', [Validators.required]],
                qty: ['', [Validators.required]],
                price: [''],
                set: ['', [Validators.required]],
                date: [''],
            }));
    }

    preValidate() {

        this.validateForm = true;
        this.shareholderForm.updateValueAndValidity()


        this.assetsNumberInvalid = false;
        // let assetsSum = 0;
        // this.assets.controls.map(control => {
        //     assetsSum += parseInt(control.get('qty').value)
        // })
        //
        // if (assetsSum !== parseInt(this.formControl('assetsTotalQty').value)) {
        //     this.assetsNumberInvalid = true;
        //     return false;
        // }

        if (!this.shareholderForm.valid) {
            return false;
        }

        this.showSummary = true;


    }

    submitFullForm() {

        this.http.post<ServerResponse>(environment.spisAkcjiUrl, this.shareholderForm.value)
            .subscribe(resp => {

                switch (resp.result) {
                    case 'no_result':
                        this.showSummary = false;
                        this.errorMessage = "Brak numeru PESEL/REGON w bazie. Prosimy o ponowną weryfikację poprawności wpisanego numeru PESEL/REGON bądź kontakt ze spółką: ir@zortrax.com";
                        break;
                    case 'exists':
                        this.showSummary = false;
                        this.errorMessage = "Dokonałeś już aktualizacji danych. W celu ich ponownego zweryfikowania skontaktuj się ze spółką: ir@zortrax.com";
                        break;
                    case '1':
                        this.showSummary = false;
                        this.errorMessage = "Zgodnie z posiadanymi przez Spółkę informacjami, wpis wymaga uzupełnienia. Prosimy o kontakt z Domem Maklerskim BOŚ prowadzącym rejestr akcjonariuszy, w celu weryfikacji i aktualizacji danych";
                        break;
                    case '0':
                        this.showSummary = false;
                        this.errorMessage = "Zgodnie z posiadanymi przez Spółke informacjami, rejestr zawiera dane potrzebne do zapisania akcji na Pani/Pana Rachunku i nie jest konieczne podejmowanie żadnych działań. W razie konieczności zmiany i aktualizacji wcześniej podanych danych prosimy o kontakt z Domem Maklerskim BOŚ";
                        break;
                    case 'success':
                        this.showThankYou = true;
                        this.showSummary = false;
                        break;
                }
                window.scrollTo(0, 0);
            }, error => {

            })


    }

}
